import { Outlet, ScrollRestoration } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container } from '@easymoving/ui';
import { TopNav } from './TopNav';

export function AppFrame() {
  const { t } = useTranslation();
  return (
    <div className="min-h-full flex flex-col">
      <TopNav />
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="print:hidden border-t hairline mt-12 py-8 text-[13px] text-graphite">
        <Container className="flex flex-col md:flex-row justify-between gap-3">
          <div>
            <span className="font-display text-[15px] text-ink">{t('brand.name')}</span>
            <span className="mx-2 opacity-50">·</span>
            <span>{t('brand.tagline')}</span>
          </div>
          <span className="font-body-en tnum text-graphite-soft">v0.0</span>
        </Container>
      </footer>
      <ScrollRestoration />
    </div>
  );
}
